<button type="button" (click)="onTarifClick()" [class.active]="plan?.id === currentActive?.id" class="tarifBlock">
  <header class="trafik">{{tarif}}</header>
  <img [src]="image" [alt]="tarif" class="tarif">
  <div class="price">{{price}}</div>
  <div *ngIf="discount" class="discount">
    {{discount}} % OFF
  </div>
</button>